import { render, staticRenderFns } from "./add-model.vue?vue&type=template&id=500a78ba&scoped=true&"
import script from "./add-model.vue?vue&type=script&lang=ts&"
export * from "./add-model.vue?vue&type=script&lang=ts&"
import style0 from "./add-model.vue?vue&type=style&index=0&id=500a78ba&prod&lang=css&"
import style1 from "./add-model.vue?vue&type=style&index=1&id=500a78ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a78ba",
  null
  
)

export default component.exports